
import HeaderCart from '@/components/HeaderCart.vue'
import HeaderSearchAlgolia from '@/components/HeaderSearchAlgolia.vue'
import logoutMixin from '@/mixins/logoutMixin'

export default {
  name: 'TheHeader',
  components: {
    HeaderSearchAlgolia,
    HeaderCart,
  },
  mixins: [logoutMixin],
  props: {
    mobileMenu: Boolean,
    showTopBanner: Boolean,
    menu: Boolean,
  },
  data() {
    return {
      rating: 4.1,
      toggledCart: false,
      toggledAccount: false,
      toggledFavorites: false,
      isDecember: false,
    }
  },
  watch: {
    $route() {
      this.toggledCart = false
      this.toggledAccount = false
      this.toggledFavorites = false
    },
  },
  created() {
    const currentMonth = new Date().getMonth()
    this.isDecember = currentMonth === 11
  },
}
